import { Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { login } from './authSlice';
import { useDispatch } from 'react-redux';
import LoadingButton from '@mui/lab/LoadingButton';
import windowLocationRedirect from '../redirect';
import TextFieldElement from '../../components/Fields/TextFieldElement';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AlertElement from '../../components/AlertElement';
import AuthService from './AuthService';

export default function LoginForm() {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const { search } = useLocation()
    const parameters = new URLSearchParams(search)

    const backLink = parameters.get("back") 

    const [email, setEmail] = useState<string>("")
    const [otp, setOtp] = useState<number | null>(null)
    const [password, setPassword] = useState<string>("")

    const { loading, error, isAuthenticated, errorStatus } = useAppSelector((state) => state.auth)
    const [successMessage, setSuccessMessage] = useState<string>("")

    const [otpRequired, setOtpRequired] = useState<boolean>(false)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        await dispatch(login({ email, password, otp: otp ? otp : 0 }))
    };

    useEffect(() => {
        if (isAuthenticated){
            setSuccessMessage("You have been successfully signed in!")
            setTimeout(() => {
                navigate(backLink ? backLink : "/")
            }, 1500)
        }
    }, [isAuthenticated])

    useEffect(() => {

        switch(errorStatus){

            case 401:
                setOtpRequired(true)
                break

        }

    }, [errorStatus])

    return(
        <div className="login-form">
            <form onSubmit={handleSubmit}>

                {error && error !== "OTP is required!" && (
                    <div className="alert-box-of-login-form">
                        <AlertElement type="error" message={error} />
                    </div>
                )}

                {successMessage && (
                    <div className="alert-box-of-login-form">
                        <AlertElement type="success" message={successMessage} />
                    </div>
                )}

                {!otpRequired && <TextFieldElement id="email" label="Email" fullWidth value={email} handleOnChange={setEmail} />}

                {!otpRequired && <TextFieldElement type="password" id="password" label="Password" fullWidth value={password} handleOnChange={setPassword} />}

                {otpRequired && <TextFieldElement type="number" id="otp" label="OTP" fullWidth value={otp} handleOnChange={setOtp} />}

                {!otpRequired && (
                    <div className="forgot-password-link-box">
                        <Link to="/forgot-password">Forgot password?</Link>
                    </div>
                )}
                
                <div className="submit-button-box-of-login-form">
                    <LoadingButton disabled={successMessage ? true : false} className="general-button" loading={loading} variant="contained" fullWidth type="submit">Sign in</LoadingButton>
                </div>
            </form>
        </div>
    )
}